import Api from './api.service'

import Configuration from '@/configuration';
const baseAdminURL = Configuration.value('apiBackend')
const baseURL = Configuration.value('apiFrontend')

export default {
  get() {
    return Api().get(`${baseAdminURL}/config`)
  },
  store(payload) {
    return Api().post(`${baseAdminURL}/config`, payload)
  },
  getMerchantConfig() {
    return Api().get(`${baseURL}/config`)
  },
  storeMerchantConfig(payload) {
    return Api().post(`${baseURL}/config`, payload)
  },
}
